import { z } from 'zod';
import { EventAttendeeTypeEnum } from './EventAttendeeTypeEnum';

export const calendarEventAttendeeSchema = z.object({
  emailAddress: z.object({
    name: z.string(), // FirstName (if exists) and LastName of legalClient
    address: z.string(), // Email of legalClient
  }),
  type: z.nativeEnum(EventAttendeeTypeEnum),
});

export type ICalendarEventAttendee = z.infer<
  typeof calendarEventAttendeeSchema
>;
